import 'babel-polyfill';

import Vue from 'vue';
import router from "./router";
import store from "./services/store";

import App from "./App";
import VueI18n from 'vue-i18n'
import i18nConfig from "./config/i18n";

import { setupPlugins } from "./plugins/setup"
import { setupGlobalComponents } from "./components/setup"
import { setupFilters } from "./utils/filter/setup"

//import "xmldom";
//import "jquery";
//import "drawerjs/dist/drawerJs.redactor";
//import "drawerjs/dist/drawerJs.css";

// Plugins

setupPlugins(Vue);

// Global Components

setupGlobalComponents(Vue);

// Filter

setupFilters(Vue);


Vue.config.productionTip = false;

if (JSON.parse(process.env.VUE_APP_DEV_TOOLS))
  Vue.config.devtools = true;

const i18n = new VueI18n(i18nConfig)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#vue-app');

